"use strict";
var IntervalObservable_1 = require('./IntervalObservable');
exports.interval = IntervalObservable_1.IntervalObservable.create;
//# sourceMappingURL=interval.js.map


//////////////////
// WEBPACK FOOTER
// ./~/rxjs/observable/interval.js
// module id = 1231
// module chunks = 33